import React, { useEffect } from "react";
import { formatTime } from "../helpers/utils";
import { PLAYER_CONSTANTS } from "../helpers/playerConstants";
import { useWaveformImage } from "../hooks/useWaveformImage";

const ProgressBar = ({ activeTrack, currentTime, currentTrackIndex, activePlaylist, onScrubberClick, onScrub, isPlaying }) => {
  const { scrubberRef, progressBarRef, fadeClass } = useWaveformImage(activeTrack);

  useEffect(() => {
    const tracksWithAudio = activePlaylist ? activePlaylist.filter(track => track.mp3_url) : [];

    if (currentTrackIndex >= 0 && currentTrackIndex < tracksWithAudio.length) {
      const currentTrack = tracksWithAudio[currentTrackIndex];
      if (currentTrack?.duration && progressBarRef.current) {
        const duration = currentTrack.duration / 1000;
        const progress = (currentTime / duration) * 100;
        const styles = getComputedStyle(document.documentElement);
        const blue = styles.getPropertyValue('--blue').trim() || '#03bbf2';
        const paused = styles.getPropertyValue('--progress-paused').trim() || '#4a95ad';
        const progressColor = isPlaying ? blue : paused;
        progressBarRef.current.style.setProperty('background', `linear-gradient(to right, ${progressColor} ${progress}%, rgba(255,255,255,0) ${progress}%)`, 'important');
      }
    }
  }, [currentTime, currentTrackIndex, activePlaylist, progressBarRef, isPlaying]);

  return (
    <div className="bottom-row">
      <p className="elapsed" onClick={() => onScrub(-PLAYER_CONSTANTS.SCRUB_SECONDS)}>
        {formatTime(currentTime)}
      </p>
      <div
        className={`scrubber-bar ${fadeClass}`}
        onClick={onScrubberClick}
        ref={scrubberRef}
      >
        <div className="progress-bar" ref={progressBarRef}></div>
      </div>
      <p className="remaining" onClick={() => onScrub(PLAYER_CONSTANTS.SCRUB_SECONDS)}>
        {activeTrack ? `-${formatTime((activeTrack.duration / 1000) - currentTime)}` : "0:00"}
      </p>
    </div>
  );
};

export default ProgressBar;
